import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function generatePdfFromElement(
  target: HTMLElement,
  filename: string,
  opts: { orientation?: "portrait" | "landscape" } = {},
) {
  const { orientation = "portrait" } = opts;
  const wasHidden = target.style.display === "none" || target.style.display === "";
  target.style.display = "block";

  try {
    const images = Array.from(target.getElementsByTagName("img"));
    await Promise.all(
      images.map((img) => {
        if (!img.complete || img.naturalWidth === 0) {
          return new Promise<void>((resolve) => {
            img.onload = () => resolve();
            img.onerror = () => resolve();
          });
        }
        return Promise.resolve();
      }),
    );

    await new Promise((r) => setTimeout(r, 200));

    const canvas = await html2canvas(target, {
      useCORS: true,
      allowTaint: false,
      scale: 2,
      backgroundColor: "#fff",
      logging: false,
    });

    if (!canvas || canvas.width <= 0 || canvas.height <= 0) {
      throw new Error("PDF生成失败，页面渲染异常，请刷新页面后重试。");
    }

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF({ orientation, unit: "mm", format: "a4" });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    let imgWidth = pdfWidth;
    let imgHeight = (canvas.height * pdfWidth) / canvas.width;
    if (imgHeight > pdfHeight) {
      imgHeight = pdfHeight;
      imgWidth = (canvas.width * pdfHeight) / canvas.height;
    }

    const x = (pdfWidth - imgWidth) / 2;
    const y = 0;

    pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);
    pdf.save(filename);
  } finally {
    if (wasHidden) target.style.display = "none";
  }
}
